module.exports = __webpack_public_path__ + "static/media/Img3.9e44be8e.png";